import { Pagination } from '../__generated__/graphql'
import { DEFAULT_QUERY_PAGINATION } from './providers/paginationContext'

export const QUERY_PAGE_SIZE = DEFAULT_QUERY_PAGINATION.limit ?? 100

export async function fetchAllPages<T>(
  fetchPage: (pagination: Pagination) => Promise<T[]>,
  pageSize: number = QUERY_PAGE_SIZE
): Promise<T[]> {
  const allItems: T[] = []
  let offset = 0

  while (true) {
    const page = await fetchPage({ limit: pageSize, offset })
    allItems.push(...page)
    if (page.length < pageSize) break
    offset += pageSize
  }

  return allItems
}
